import React, {Component} from 'react';
import './GuestlistScreen.css';
import RmField from "../../Forms/RmField";
import PropTypes from 'prop-types';
import GuestlistCategoryDropdown from "./GuestlistCategoryDropdown";

export default class GuestlistAddEntry extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nameFirst: "",
            nameLast: "",
            categoryName: ""
        };
    }

    handleNameFirstChange(value) {
        this.setState({
            nameFirst: value
        });

        setTimeout(() => {
            this.fireOnChange();
        }, 0);
    }

    handleNameLastChange(value) {
        this.setState({
            nameLast: value
        });

        setTimeout(() => {
            this.fireOnChange();
        }, 0);
    }

    handleCategoryNameChange(value) {
        this.setState({
            categoryName: value
        });

        setTimeout(() => {
            this.fireOnChange();
        }, 0);
    }

    fireOnChange() {
        if (this.props.onChange) {
            let payload = {
                nameFirst: this.state.nameFirst,
                nameLast: this.state.nameLast,
                categoryName: this.state.categoryName
            };

            this.props.onChange(payload);
        }
    }

    render() {
        return (
            <tr>
                <td width="30%">
                    <RmField id={"name_first"} label={"Voornaam"} onChange={this.handleNameFirstChange.bind(this)}
                             disableClear={true} marginOff={true} nonUnique={true} value={this.state.nameFirst}/>
                </td>
                <td width="35%">
                    <RmField id={"name_last"} label={"Achternaam"} onChange={this.handleNameLastChange.bind(this)}
                             disableClear={true} marginOff={true} nonUnique={true} value={this.state.nameLast}/>
                </td>
                <td width="35%">
                    <GuestlistCategoryDropdown onChange={this.handleCategoryNameChange.bind(this)}
                                               value={this.state.categoryName}/>
                </td>
            </tr>
        );
    }
}

GuestlistAddEntry.propTypes = {
    onChange: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistAddEntry.js